import React from "react"
import { StaticQuery, graphql } from "gatsby"
import SignUp from '../main/SignUp'

const Layout = () => (
  <StaticQuery
    query={graphql`
      query {
				allSlidesYaml {
					edges {
						node {
							slide {
								image
                title
                subtitle
                date
                description
                custom
                newsletter
                c4p
                hackathon
                grill,
                finished
							}
						}
					}
				}
			}
    `}

    render={data => (
      <div id="tg-homeslider" className="tg-homeslider tg-haslayout owl-carousel">
        {
          data.allSlidesYaml.edges.map(({ node: { slide: { image, title, subtitle, date, description, custom, newsletter, c4p, previous, hackathon, grill, finished } } }, index) => {
            let imageUrl = `images/banner/${image}.jpg`;
              return (
                <figure className="tg-themepostimg item" key={index}>
                  <img className='fullscreen-height' src={imageUrl} alt={title} />
                  <figcaption>
                    <div className="container">
                      <div className="row">
                        <div className="tg-slidercontent">
                          <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                            <div className="tg-appcontent">
                              <div className="tg-sectionhead">
                                <div className="tg-sectionheading">
                                  <h2>{title}</h2>
                                  <h3>{subtitle}</h3>
                                  {date}
                                </div>
                                <div className="tg-description">
                                  <p>{description}</p>
                                  {hackathon &&
                                  <p>
                                    <a className="tg-btn -tickets-button" href="https://evenea.pl/pl/wydarzenie/bbdays4it2020?fbclid=IwAR0htNyR6ZELSBO3NpVzE0ijZYkGTj3IoD-e9Yi_4CTcJIzvX-a9EnqktW0" target="_blank">Zapisz się teraz</a>
                                  </p>
                                  }
                                  {grill &&
                                  <p>
                                    <a className="tg-btn -tickets-button" href="http://bbq4.it/rejestracja.php" target="_blank">Dodaj grillowisko</a>
                                  </p>
                                  }
                                  {custom &&
                                  <p>
                                    <a className="tg-btn -tickets-button" target="_blank" href="https://www.youtube.com/watch?v=1g4rcdop8DQ" rel="noopener noreferrer">Zobacz jak było</a>
                                  </p>
                                  }
                                  {finished &&
                                  <p>
                                    <a className="tg-btn -tickets-button" target="_blank" href="https://www.youtube.com/playlist?list=PLThJ0XTsPK12DfmbyBhMEPK6D0U9ZVG6y">Obejrzyj nagrania</a>
                                  </p>
                                  }
                                  {c4p &&
                                  <p>
                                    <a className="tg-btn -tickets-button" href="https://selleo.typeform.com/to/Q3ScAz" target="_blank">Call for papers</a>
                                  </p>
                                  }
                                  {newsletter &&
                                    <form className="tg-formtheme tg-formsingup" method="post" action="https://app.freshmail.com/pl/actions/subscribe/">
                                      <input type="hidden" name="subscribers_list_hash" value="rqmrra28h7" />
                                      <fieldset>
                                        <div className="form-group">
                                          <input type="email" name="freshmail_email" className="form-control input-newsletter" placeholder="Wpisz swój email..." />
                                          <button type="submit" className="tg-btn btn-newsletter tg-btn__nobackground">Zapisz się</button>
                                        </div>
                                      </fieldset>
                                    </form>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </figcaption>
                </figure>
              )
            // }
          })
        }

      </div>
    )}
  />
)

export default Layout
